export { default } from './PdpXsellCarousel';